import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAuth } from '../AuthContext';
import { Link, withRouter } from 'react-router-dom';

class PhoneNumberVerify extends Component {
  constructor(props) {
    super(props);
    this.state = { phone: '', token: '', valid: true, errorText: '' };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resend = this.resend.bind(this);
    this.editPhone = this.editPhone.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit() {
    const headers = {
      'Content-Type': 'application/json'
    };

    const data = {
      token: this.state.token
    };

    axios
        .post('/api/verify-phone', data, headers)
        .then(response => {
            this.props.auth.refreshUser();
            this.props.history.push('/dashboard');
        })
        .catch(error => {
            this.setState({ valid: false, errorText: 'Incorrect verification code entered' });
        });
  }

  resend() {
    axios
      .post('/api/send-sms-token')
      .then(response => {
        // console.log(response);
      })
      .catch(function(error) {
        console.log('Request failure: ', error);
      });
  }

  editPhone() {
    this.props.history.push('/dashboard/phonenumber');
  }

  render() {
    const u = this.props.auth.user;

    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="contact_form">
                <h3 className="title">Phone number verification</h3>

                <div>
                  <p>
                    You have received a SMS with a 4 digit code on your mobile
                    phone or you have received a voice message containing a 4
                    digit code from your fixed phone line. If you have not
                    received a verification code, please check your phone number
                    below.
                  </p>
                </div>

                <form
                  method="POST"
                  action="/"
                  name="myForm"
                  aria-label="Verify Phone Number"
                  onSubmit={event => {
                    event.preventDefault();

                    return false;
                  }}>
                  <input
                    type="hidden"
                    name="csrf-token"
                    value={window.Laravel.csrfToken}
                  />
                  <div className="row">
                    <div className="col-12  form-group">
                      <label>Your mobile phone number</label>

                      <label htmlFor="phone" className="col-md-6">
                        {u.phoneCodeId && u.phone ? `${u.phoneCodeId} ${
                          u.phone
                        }` : 'None provided'}
                      </label>
                    </div>

                    <div className="col-12  form-group">
                      <label>Verification code</label>

                      <input
                        id="token"
                        type="text"
                        name="token"
                        required
                        autoFocus
                        value={this.state.token}
                        onChange={this.handleInputChange}
                      />
                    </div>

                    <div
                      className="col-12 form-group"
                      style={{
                        visibility: this.state.valid ? 'hidden' : 'visible'
                      }}>
                      <label style={{ color: 'red' }}>
                        {this.state.errorText}
                      </label>
                    </div>

                    <div className="btn-toolbar">
                      <div className="submit-btn">
                        <button
                          onClick={this.handleSubmit}
                          className="btn btn-primary mr-2 mb-2">
                          Verify
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="btn-toolbar mb-2">
                  <button
                    onClick={this.resend}
                    className="btn btn-primary mr-2">
                    Resend Code
                  </button>
                  <Link to="/dashboard/edit-phonenumber">
                    <button className="btn btn-primary">
                      Edit Phone Number
                    </button>
                  </Link>
                </div>
                <p>
                  Only click "Send me a new code" if you have not received a
                  code on your phone. If you select this and still do not
                  receive a verification code, please contact
                  hello@thefreebirdclub.com for assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(withAuth(PhoneNumberVerify));
